/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipAltReportEvidenceExportUrl1QueryResponse, GetGipAltReportEvidenceExportUrl1PathParams, GetGipAltReportEvidenceExportUrl1404 } from "../models/GetGipAltReportEvidenceExportUrl1";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getGipAltReportEvidenceExportUrl1 } from "../axios/getGipAltReportEvidenceExportUrl1";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getGipAltReportEvidenceExportUrl1QueryKey = (id: GetGipAltReportEvidenceExportUrl1PathParams["id"]) => ["audit-reports-api", { url: '/reports/gip-alt/report/:id/export-url', params: {id:id} }] as const

export type GetGipAltReportEvidenceExportUrl1QueryKey = ReturnType<typeof getGipAltReportEvidenceExportUrl1QueryKey>

export function getGipAltReportEvidenceExportUrl1QueryOptions(id: GetGipAltReportEvidenceExportUrl1PathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getGipAltReportEvidenceExportUrl1QueryKey(id)
        return queryOptions<GetGipAltReportEvidenceExportUrl1QueryResponse, ResponseErrorConfig<GetGipAltReportEvidenceExportUrl1404>, GetGipAltReportEvidenceExportUrl1QueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getGipAltReportEvidenceExportUrl1(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export URL for existing report
 * {@link /reports/gip-alt/report/:id/export-url}
 */
export function useGetGipAltReportEvidenceExportUrl1<TData = GetGipAltReportEvidenceExportUrl1QueryResponse, TQueryData = GetGipAltReportEvidenceExportUrl1QueryResponse, TQueryKey extends QueryKey = GetGipAltReportEvidenceExportUrl1QueryKey>(id: GetGipAltReportEvidenceExportUrl1PathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetGipAltReportEvidenceExportUrl1QueryResponse, ResponseErrorConfig<GetGipAltReportEvidenceExportUrl1404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getGipAltReportEvidenceExportUrl1QueryKey(id)
         

         const query = useQuery({
          ...getGipAltReportEvidenceExportUrl1QueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetGipAltReportEvidenceExportUrl1404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}